import RandingStyle1 from "../../randing/RandingStyle1";
import RandingStyle2 from "../../randing/RandingStyle2";
// import { Helmet } from "react-helmet";

function Randing023({ urlCode, urlCodeSettingId }) {
  return (
    <>
      <RandingStyle1
        urlCode={urlCode}
        urlCodeSettingId={urlCodeSettingId}
        totalStep="2"
        img1Path={`${process.env.REACT_APP_CDN_BASE}/images/023/20241121_01.jpg`}
        img2Path={`${process.env.REACT_APP_CDN_BASE}/images/023/20241121_02.gif`}
        img3Path={`${process.env.REACT_APP_CDN_BASE}/images/023/20241121_02.gif`} // 스텝 변경되는 이미지
        numberColor="#0854fc"
        qOptionColor="blue"
        keepBTN={`${process.env.REACT_APP_CDN_BASE}/images/004/01_241105_03.png`}
        postBTN={`${process.env.REACT_APP_CDN_BASE}/images/004/01_241105_04.png`}
        companyName="쿨쿨플란트치과의원"
        // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/woori.jpg`}
      />
    </>
  );
}

export default Randing023;
